import React from "react";
import { Text } from "@merge-api/merge-javascript-shared";
import { renderWorkdayEmployeesEndpointStatus } from "../modal/helpers";

type FieldMappingCardRemoteFieldsSubtitleProps = {
  exampleValue?: string | null;
  jsonAdvancedMappingExpression?: string | null;
  remoteEndpointMethod: string | null;
  remoteEndpointPath: string;
};
const FieldMappingCardRemoteFieldsSubtitle = ({
  exampleValue,
  jsonAdvancedMappingExpression,
  remoteEndpointMethod,
  remoteEndpointPath,
}: FieldMappingCardRemoteFieldsSubtitleProps) => {
  return (
    <Text
      variant="sm"
      className="flex flex-col w-full gap-y-2 whitespace-normal break-all text-wrap text-gray-40"
    >
      {exampleValue ? (
        <span>
          Value: <span className="ph-no-capture">{JSON.stringify(exampleValue)}</span>
        </span>
      ) : (
        jsonAdvancedMappingExpression && (
          <span>
            Advanced: <span className="ph-no-capture">{jsonAdvancedMappingExpression}</span>
          </span>
        )
      )}
      <span>
        <span className="mr-1 font-semibold">{remoteEndpointMethod}</span>
        {remoteEndpointPath ?? "/"}
        {"  "}
        {renderWorkdayEmployeesEndpointStatus(remoteEndpointPath)}
      </span>
    </Text>
  );
};

export default FieldMappingCardRemoteFieldsSubtitle;
